export const ADD_ENTITY = "ADD_ENTITY";
export const MERGE_ENTITY = "MERGE_ENTITY";
export const MERGE_ENTITIES = "MERGE_ENTITIES";
export const MERGE_AND_REPlACE = "MERGE_AND_REPlACE";
export const SYNC_ENTITIES = "SYNC_ENTITIES";
export const SYNC_ARRAY_ENTITIES = "SYNC_ARRAY_ENTITIES";
export const DELETE_ENTITY = "DELETE_ENTITY";
export const ADD_ENTITY_PERMISSION = "ADD_ENTITY_PERMISSION";